const SearchPageSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <g clipPath="url(#clip0_3860_302)">
        <path
          d="M12.6063 20.0772C17.1913 20.0772 20.908 16.3605 20.908 11.7755C20.908 7.19058 17.1913 3.47388 12.6063 3.47388C8.02139 3.47388 4.30469 7.19058 4.30469 11.7755C4.30469 16.3605 8.02139 20.0772 12.6063 20.0772Z"
          fill="white"
          stroke="white"
          strokeWidth="1.95333"
          strokeLinejoin="round"
        />
        <path
          d="M15.3688 8.52478C15.0064 8.16148 14.5758 7.87337 14.1017 7.67702C13.6276 7.48066 13.1194 7.37993 12.6063 7.38062C12.0931 7.37993 11.5849 7.48066 11.1108 7.67702C10.6367 7.87337 10.2061 8.16148 9.84375 8.52478"
          fill="white"
        />
        <path
          d="M15.3688 8.52478C15.0064 8.16148 14.5758 7.87337 14.1017 7.67702C13.6276 7.48066 13.1194 7.37993 12.6063 7.38062C12.0931 7.37993 11.5849 7.48066 11.1108 7.67702C10.6367 7.87337 10.2061 8.16148 9.84375 8.52478"
          stroke="#5D6977"
          strokeWidth="1.95333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M18.5752 17.7441L22.7187 21.8876L18.5752 17.7441Z" fill="white" />
        <path d="M18.5752 17.7441L22.7187 21.8876" stroke="white" strokeWidth="1.95333" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3860_302">
          <rect width="24.9576" height="24.9576" fill="white" transform="translate(0.145508 0.354248)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchPageSvg;
